// MetaTagsHelmet.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

import { EMPTY_ARRAY } from '../resource/defaults.js';

export const MetaTagsHelmet = ({ metaTags = EMPTY_ARRAY }) => {
  if (!metaTags || metaTags.length === 0) {
    return null;
  }

  return (
    <>
      <Helmet>
        {metaTags.map((metaProps, index) => {
          // Handle JSON-LD script tag
          if (metaProps['script:ld+json']) {
            try {
              const jsonLdString = JSON.stringify(metaProps['script:ld+json']);
              return (
                <script key={`jsonld-${index}`} type="application/ld+json">
                  {jsonLdString}
                </script>
              );
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error('Failed to stringify JSON-LD:', {
                error,
                jsonData: metaProps['script:ld+json'],
              });
              return null;
            }
          }

          // Handle title tag
          if (metaProps.title) {
            return <title key={`title-${index}`}>{metaProps.title}</title>;
          }

          // Handle tagName for custom elements
          if (metaProps.tagName) {
            const { tagName, ...rest } = metaProps;
            const Component = tagName;
            return <Component key={`${tagName}-${index}`} {...rest} />;
          }

          // Handle regular meta tags
          return <meta key={`meta-${index}`} {...metaProps} />;
        })}
      </Helmet>
    </>
  );
};

MetaTagsHelmet.propTypes = {
  metaTags: PropTypes.arrayOf(PropTypes.object),
};

export default MetaTagsHelmet;
